module.exports = __webpack_public_path__ + "static/media/html.25b694ba.png";